// src/Pages/About/About.jsx
import React from 'react';
import Navbar from '../../Components/Navbar';
import './style.css';
import str from "../../assests/About/str.jpeg"
import Footer from '../../Components/Footer';
import Load from '../Load';
import aboutVideo from "../../assests/Video/about.mp4"


export default function About() {
    return (
        <>
            <div className="svg-wave-top">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path
                        fill="#273036"
                        fillOpacity="1"
                        d="M0,128L120,160C240,192,480,256,720,245.3C960,235,1200,149,1320,106.7L1440,64L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"
                    ></path>
                </svg>
            </div>

            <Navbar />
            <video
                className="about-video-banner"
                src={aboutVideo}
                autoPlay
               controls
                loop
                muted
                playsInline
            ></video>

            <div className="about-container">
                <div className="about-content">
                    <h1>About Us</h1>

                    <div className="quote-block">
                        <p>
                            Innovation Solution is a Singapore-based company providing top-quality construction, MEP, demolition, and security system services tailored to meet the demands of modern infrastructure and safety.
                        </p>
                        <p>
                            We specialize in delivering comprehensive, integrated solutions—from structural repairs and advanced demolition methods to high-performance air conditioning, electrical installations, and state-of-the-art security systems including AI-powered CCTV and access control.
                        </p>
                        <p>
                            With a strong focus on quality, safety, and innovation, we serve residential, commercial, and industrial sectors. Our team of experienced professionals is committed to customizing each project to client needs, using advanced technology, precise engineering, and industry best practices to ensure long-lasting results.
                        </p>
                        <p>
                            Established in 2023, we are proud to be at the forefront of modern infrastructure services in Singapore.
                        </p>
                    </div>
                </div>
            </div>

            <div className="strength-section">
                <div className="strength-box">
                    <h2 className="strength-title">OUR STRENGTH</h2>
                    <div className="strength-image">
                        <img src={str} alt="Our Strength" />
                    </div>
                    <div className="strength-content">
                        <ul>
                            <li>
                                <h4>Safety is Our Priority</h4>
                                <p>We strictly adhere to industry safety standards to ensure a safe working environment for all personnel on site.</p>
                            </li>
                            <li>
                                <h4>Qualified & Trained Workforce</h4>
                                <p>All operations are carried out by skilled professionals under the guidance of certified supervisors and safety officers.</p>
                            </li>
                            <li>
                                <h4>Strict Quality & Control Measures</h4>
                                <p>From planning to execution, we implement rigorous control systems to maintain high standards in every aspect of our work.</p>
                            </li>
                            <li>
                                <h4>Commitment to Improvement</h4>
                                <p>We continuously invest in training, safety upgrades, and process enhancements to deliver better results every time.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="values-container">



                <div className="diagram-wrapper">

                    {/* Mission */}
                    <div className="orbit-container orbit-red" style={{ top: '0', left: '50%', transform: 'translateX(-50%)' }}>
                        <div className="orbit-path"></div>
                        <div className="orbiting-wrapper">
                            <div className="orbiting-circle">
                                <span className="orbit-label">MISSION</span>
                            </div>
                        </div>
                    </div>

                    {/* Mission description */}
                    <div className="textbox mission-box">
                        <div className="box-title">OUR MISSION</div>
                        <p>Our mission is to deliver exceptional construction solutions through teamwork, integrity, and expertise, while maintaining the highest standards of safety, quality, and client satisfaction.</p>
                    </div>

                    {/* Values */}
                    <div className="orbit-container orbit-green" style={{ bottom: '0', left: '10%' }}>
                        <div className="orbit-path"></div>
                        <div className="orbiting-wrapper">
                            <div className="orbiting-circle">
                                <span className="orbit-label">VALUES</span>
                            </div>
                        </div>
                    </div>

                    <div className="textbox values-box">
                        <div className="box-title">OUR VALUES</div>
                        <ul className="values-list">
                            <li><strong>Safety First</strong><br />We prioritize the health and safety of our workers, clients, and communities in everything we do.</li>
                            <li><strong>Integrity</strong><br />We conduct our business with honesty, transparency, and accountability.</li>
                            <li><strong>Collaboration</strong><br />We believe in the power of teamwork — with our clients, partners, and within our team.</li>
                            <li><strong>Innovation</strong><br />We embrace new technologies and methods to build smarter, faster, and more efficiently.</li>
                            <li><strong>Reliability</strong><br />We deliver on our promises — on time, on budget, and to specification.</li>
                        </ul>
                    </div>

                    {/* Vision */}
                    <div className="orbit-container orbit-orange" style={{ bottom: '0', right: '10%' }}>
                        <div className="orbit-path"></div>
                        <div className="orbiting-wrapper">
                            <div className="orbiting-circle">
                                <span className="orbit-label">VISION</span>
                            </div>
                        </div>
                    </div>

                    {/* Vision description */}
                    <div className="textbox vision-box">
                        <div className="box-title">OUR VISION</div>
                        <p>To lead the construction industry by delivering innovative, reliable, and sustainable solutions that shape the communities of tomorrow — building the future, today</p>
                    </div>

                </div>




            </div>
            <Footer />


        </>
    );
}
